export default "__VITE_ASSET__7y0RT1N4__"